import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  explore: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(3, 1fr)',
    gap: 16,
  },
  container: {
    ...dFlex('initial', 'initial'),
    backgroundColor: theme.palette.custom.background.medium,
    borderRadius: 8,
    flexDirection: 'column',
    gap: 16,
    padding: 16,
    width: '100%',
  },
  link: {
    paddingLeft: 16,
  },
}));

export default useStyles;
